import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TbAlertCircle, TbDeviceMobile, TbDeviceMobileOff } from 'react-icons/tb';

import { useTranslation } from '../../context/TranslationContext.jsx';

import {
  StatusBannerProgress,
  StatusBannerRoot,
  StatusBannerText,
  StatusIconContainer,
} from './styles';

const getStatusMessageKey = (statusCode) => {
  switch (statusCode) {
    case 100:
      return 'phoneWidget.notFound';
    case 101:
      return 'phoneWidget.notConnected';
    case 102:
      return 'phoneWidget.multipleFound';
    case 103:
      return 'phoneWidget.batteryLow';
    case 104:
      return 'phoneWidget.connectionSlow';
    case 200:
      return 'phoneWidget.connected';
    case 503:
    case 504:
      return 'phoneWidget.takingTooLong';
    default:
      return 'statusMessages.phoneNotConnected';
  }
};

const PhoneStatusBanner = ({ status_code, message }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const { translate } = useTranslation();
  const isChecking = !status_code && !message;
  const statusColor = isChecking
    ? theme.palette.info.main
    : status_code === 200
      ? theme.palette.primary.main
      : status_code === 503 || status_code === 504
        ? theme.palette.warning.main
        : theme.palette.error.main;
  const iconSize = isLargeScreen ? 24 : 20;
  const displayMessage = isChecking
    ? translate('phoneWidget.checkingStatus')
    : message || translate(getStatusMessageKey(status_code));
  const icon =
    status_code === 200 ? (
      <TbDeviceMobile size={iconSize} />
    ) : status_code === 503 || status_code === 504 ? (
      <TbAlertCircle size={iconSize} />
    ) : (
      <TbDeviceMobileOff size={iconSize} />
    );

  return (
    <StatusBannerRoot role="status" aria-live="polite" statusColor={statusColor}>
      <StatusIconContainer statusColor={statusColor}>{icon}</StatusIconContainer>
      <StatusBannerText component="span" statusColor={statusColor}>
        {displayMessage}
      </StatusBannerText>
      {isChecking ? (
        <StatusBannerProgress
          size={isLargeScreen ? 20 : 18}
          thickness={4}
          aria-label={translate('phoneWidget.checkingStatus')}
          statusColor={statusColor}
        />
      ) : null}
    </StatusBannerRoot>
  );
};

export default PhoneStatusBanner;
